<template>
    <div class="nodeSearch">
        <Row :gutter="4">
            <div v-if="company==1">
                <Col span="4">
                    <Select v-model="companyId" filterable :placeholder="$t('configuration_management.common.pleaseSelectCompany')" :transfer="true" @on-change="searchCompany">
                        <Option value=" " selected>{{ $t('configuration_management.common.all') }}</Option>
                        <Option :value="item.id" v-for="item in companyList" :key="item.id">{{item.name}}</Option>
                    </Select>
                </Col>
            </div>
            <Col span="4">
                <Input search v-model="nodeNameKey" :placeholder="$t('approvalFlowConfigManagement.Node.queryByNodeName')" @on-search="searchNodeName()"/>
            </Col>
            <Col span="4">
                <add-node></add-node>
            </Col>
        </Row>
    </div>
</template>
<script>
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    import AddNode from '../node/AddNode'
    import TableNode from '../node/TableNode'
    var tableNode = TableNode;
    export default {
        name: 'NodeSearch',
        components: {
            AddNode
        },
        data () {
            return {
                company: getCookie(global.companyId),
                companyId: '',
                companyList: [],
                nodeNameKey:''
            }
        },
        mounted: function(){
            if (this.company == 1) {
                this.getCompanyDropDownBox();
            }
        },
        methods: {
            searchNodeName: function(){
                this.listApprovalNode();
            },
            // 获取公司下拉框
            getCompanyDropDownBox: function(){
                this.$api.company.getCompanyDropDownBox("userName",getCookie(global.cookieName))
                    .then(res => {
                        this.companyList = res.data;
                    });
            },
            // 按公司搜索
            searchCompany: function(){
                this.listApprovalNode();
            },
            // 查询审批流列表
            listApprovalNode: function () {
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('companyIdVal', this.companyId);
                eventBus.$emit('nodeName', this.nodeNameKey);
                tableNode.methods.showAll();
            }
        }
    }
</script>
<style scoped>
    .nodeSearch
    {
        padding: 4px 0px 15px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/approval_flow_configuration/node/NodeSearch.vue